import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { purchaseReturnViewAction } from "../../../redux/actions/purchase-action";
import CreateEditViewPurReturn from "../../../components/purchase-section/purchase-return/create-edit-view-pur-return";

const ViewPurchaseReturn = () => {
  const { id } = useParams();

  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true);
    dispatch(purchaseReturnViewAction(id, onSuccPur, onErrPur));
  }, []);

  const onSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };

  return (
    <InnerLayout backBtn={true} title="Purchase Return View">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <CreateEditViewPurReturn
          // <CreateEditViewPurchaseReturn
          payto={orderDetail?.orderData?.prt_pay_to_address}
          shipto={orderDetail?.orderData?.prt_ship_to_address}
          pageType="purchase return"
          page="view"
          disabled={true}
          data={orderDetail}
          orderDetail={orderDetail?.itemData}
          vendorDetails={[orderDetail?.orderData]}
        />
      )}
    </InnerLayout>
  );
};

export default ViewPurchaseReturn;
